import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import {
  downloadDeviceStatistics,
  downloadDeviceOffboardStatistics,
} from "../../action/statistics";
import Alert from "../layout/Alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import { Box, Grid, FormControl, Select, MenuItem } from "@mui/material";
import { selectMenuProps } from "../../utils/selectMenuProps";
import "./Statistics.css";

const Statistics = ({
  stats,
  downloadDeviceStatistics,
  downloadDeviceOffboardStatistics,
  allowedDeviceCategories,
  wrapperClass,
  ...props
}) => {
  const [category, setCategory] = useState(allowedDeviceCategories?.[0] ?? "");

  return (
    <Fragment>
      <ResponsiveContentWrapper className={wrapperClass || ""}>
        <Alert />
        <Box sx={{ width: "100%", minWidth: 0 }}>
          <Box className="page-title" sx={{ mb: 2 }}>
            <Box component="h3" sx={{ m: 0 }}>Download Statistics</Box>
          </Box>
          <Box className="content-block bottom-shadow">
            <Grid container>
              <Grid item xs={12}>
                <Box className="table-wrapper statistics-download-table-wrap" sx={{ overflowX: "auto", width: "100%", minWidth: 0 }}>
                  <table width="100%" className="table statistic style-4 statistics-download-table">
                    <thead>
                      <tr>
                        <th className="statistics-col-description">Files description</th>
                        <th className="statistics-col-category" width="160">Device Category</th>
                        <th className="statistics-col-download" width="150">Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="statistics-col-description">Device Statistics</td>
                        <td className="statistics-col-category" width="160">
                          <Box sx={{ width: "100%", maxWidth: { xs: "100%", md: 280 }, boxSizing: "border-box" }} className="statistics-cell-category">
                            <div className="control-capabilities">
                              <div className="model-srch reset">
                                <FormControl size="small" fullWidth variant="outlined">
                                  <Select
                                    name="searchBy"
                                    value={category}
                                    onChange={(e) => setCategory(e.target.value)}
                                    MenuProps={selectMenuProps}
                                  >
                                    {allowedDeviceCategories.length && allowedDeviceCategories.map((element) => (
                                      <MenuItem key={element} value={element}>{element}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </div>
                            </div>
                          </Box>
                        </td>
                        <td className="statistics-col-download" width="150">
                          <div className="statistics-cell-download">
                            <button
                              type="button"
                              className="lnkBtn download-icn"
                              onClick={() => downloadDeviceStatistics(category)}
                            >
                              <i className="material-icons reset-icon">file_download</i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </ResponsiveContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  stats: state.statistics,
  permissions: state.auth.permissions,
  allowedDeviceCategories:state.auth.allowedDeviceCategories,
});

export default connect(mapStateToProps, {
  downloadDeviceStatistics,
  downloadDeviceOffboardStatistics,
})(Statistics);
